import { ApolloError } from "apollo-client"

export enum ErrorMessages {
  "GraphQL error: We support only percentage type discounts" = "Uh oh! There's an issue with your account. Please contact us at care@withcove.com",
  "GraphQL error: Your card has expired" = "Your card has expired",
  "GraphQL error: Your card number is incorrect." = "Your card number is incorrect."
}

export const mapApolloError = (error: ApolloError) => {
  const message = ErrorMessages[error.message as keyof typeof ErrorMessages]

  return message
    ? {
        ...error,
        message
      }
    : error
}
